import { render, staticRenderFns } from "./InvoicesAndCreditNotesB2B.vue?vue&type=template&id=244d37a8&"
import script from "./InvoicesAndCreditNotesB2B.vue?vue&type=script&lang=js&"
export * from "./InvoicesAndCreditNotesB2B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports